import {format} from "date-fns"

import {getDateFnsLocale} from "../../../utils/dateArithmetics"

export const formatDate = (date: number, pattern = "d MMM") => format(date, pattern, getDateFnsLocale())
